function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg110Belarus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#A2001D"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.261,
    y: 345.043,
    style: {
      fill: "#6DA544"
    },
    width: 361.739,
    height: 166.957
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M19.478,461.52l27.826-49.692L75.13,461.52l27.826-49.692l27.826,49.692L102.96,512h47.303v-0.002   V345.045v-22.261V0H102.96l27.825,49.688l-27.826,50.483L75.133,49.688l-27.826,50.483L19.48,49.688L47.303,0H0v345.045V512h47.303   L19.478,461.52z M102.958,374.726l-27.826-50.483l-27.826,50.483l-27.826-50.483l27.826-49.692l27.826,49.692l27.826-49.692   l27.826,49.692L102.958,374.726z M47.304,137.274l27.826,49.692l27.826-49.692l27.826,49.692l-27.826,50.483L75.13,186.966   l-27.826,50.483l-27.826-50.483L47.304,137.274z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "75.132,461.52 47.307,512 102.955,512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "75.132,49.688 102.957,0 47.307,0  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "130.784,186.966 102.958,137.274 75.132,186.966 102.958,237.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "47.304,237.449 75.132,186.966 47.304,137.274 19.478,186.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "102.958,274.551 75.132,324.244 102.958,374.726 130.784,324.244  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "19.478,324.244 47.304,374.726 75.132,324.244 47.304,274.551  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "130.784,461.52 102.958,411.828 75.132,461.52 102.955,512 102.96,512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "75.132,461.52 47.304,411.828 19.478,461.52 47.303,512 47.307,512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "75.132,49.688 102.958,100.172 130.784,49.688 102.96,0 102.957,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "19.478,49.688 47.304,100.172 75.132,49.688 47.307,0 47.303,0  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg110Belarus);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };